module.exports = __webpack_public_path__ + "img/mainMS.000135a5.jpg";